import { render } from "./about-testimonial.vue?vue&type=template&id=69064ee7"
import script from "./about-testimonial.vue?vue&type=script&lang=js"
export * from "./about-testimonial.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__